export default {
	firstName: "Prénom",
	lastName: "Nom de famille",
	nickname: "Surnom",
	email: "E-mail",
	name: "Nom",
	birthDate: "Date de naissance",
	firstVisitDate: "Première visite",
	gender: "Genre",
	cpf: "CPF",
	rg: "Pièce d'identité",
	maritalStatus: "État civil",
	type: "Type",
	phone: "Téléphone",
	mobile: "Portable",
	whatsappOptIn: "Accepte de recevoir des avis par WhatsApp",
	whatsappOptInHint: "La personne autorise la réception des charges et avis du temple par WhatsApp, envoyés depuis le numéro officiel de l'ORI (consentement LGPD)",
	address: "Adresse",
	street: "Voie",
	addressNumber: "Numéro",
	addressComplement: "Complément",
	neighborhood: "Quartier",
	city: "Ville",
	state: "État (UF)",
	zipCode: "Code postal",
	zipCodeNotFound: "Code postal introuvable",
	zipCodeLookupFailed: "Impossible de consulter le code postal pour le moment — saisissez l'adresse à la main",
	paiDeCabeca: "Père de tête",
	maeDeCabeca: "Mère de tête",
	fatherName: "Nom du père",
	motherName: "Nom de la mère",
	nationality: "Nationalité",
	occupation: "Profession",
	emergencyContactName: "Contact d'urgence",
	emergencyContactPhone: "Téléphone d'urgence",
	bloodType: "Groupe sanguin",
	healthNotes: "Santé et médication",
	healthNotesHint:
		"Problèmes de santé, allergies et traitements en cours. Donnée sensible au sens de la LGPD — seuls les dirigeants la voient et la modifient.",
	healthAdminOnly: "Seuls les dirigeants voient les données de santé",
	imageUseConsent: "Autorise l'usage de l'image",
	imageUseConsentHint:
		"La personne autorise le temple à utiliser son image dans des photos et vidéos (consentement LGPD)",
	imageUseConsentSince: "Autorisé le {date}",
	notes: "Observations",
	sections: {
		personal: "Données",
		address: "Adresse",
		family: "Famille",
		emergency: "Contact d'urgence",
		health: "Santé",
		consents: "Autorisations",
		permissions: "Autorisations",
		spiritual: "Spirituel",
	},
	fullRegistration: "Fiche complète",
	tabs: {
		basic: "Informations de base",
		functions: "Fonctions",
		guides: "Guides",
		journey: "Parcours",
	},
	types: {
		medium: "Médium",
		assistencia: "Assistance",
	},
	// Clés identiques aux valeurs de l'enum Prisma — le libellé vient de
	// `people.genders[person.gender]`, sans table de conversion.
	genders: {
		MALE: "Masculin",
		FEMALE: "Féminin",
		OTHER: "Autre",
	},
	maritalStatuses: {
		SINGLE: "Célibataire",
		MARRIED: "Marié(e)",
		STABLE_UNION: "Union libre",
		DIVORCED: "Divorcé(e)",
		WIDOWED: "Veuf/Veuve",
	},
	edit: "Modifier la personne",
	create: "Créer une personne",
	messages: {
		invalidForm: "Vérifiez les champs signalés avant d'enregistrer",
		loading: "Chargement de la personne...",
		loadError: "Erreur lors du chargement de la personne",
		created: "{name} a été créé(e) avec succès",
		updated: "{name} a été mis(e) à jour avec succès",
		deleted: "{name} a été supprimé(e) avec succès",
		createError: "Erreur lors de la création de la personne",
		updateError: "Erreur lors de la mise à jour de la personne",
		deleteError: "Erreur lors de la suppression de la personne",
	},
	mediums: {
		searchPlaceholder: "Rechercher un médium...",
		filters: {
			all: "Tous",
			journeyStage: "Étape du parcours",
			orixa: "Orixá",
			function: "Fonction",
		},
		newMedium: "Nouveau médium",
		table: {
			code: "Code",
			name: "Nom",
			journey: "Parcours",
			orixas: "Orixás",
			function: "Fonction",
			contact: "Contact",
		},
		tooltips: {
			view: "Voir le profil",
			edit: "Modifier",
			journey: "Gérer le parcours",
		},
		empty: {
			title: "Aucun médium trouvé",
			description: "Essayez d'ajuster les filtres ou ajoutez un nouveau médium à la lignée",
		},
		stats: {
			total: "Total",
			active: "Actifs",
		},
	},
	consultants: {
		empty: {
			description: "Essayez d'ajuster les filtres ou inscrivez un nouveau consultant",
			title: "Aucun consultant trouvé",
		},
		filters: {
			all: "Tous",
			recent: "Récents",
			withReturn: "Avec retour",
			withTickets: "Avec fiches",
		},
		neverAttended: "Jamais présent",
		newConsultant: "Nouveau consultant",
		return: "Retour",
		searchPlaceholder: "Rechercher un consultant...",
		stats: {
			returns: "Retours",
			total: "Total",
			withTickets: "Avec fiches",
		},
		table: {
			birthday: "Anniversaire",
			code: "Code",
			contact: "Contact",
			lastVisit: "Dernière visite",
			name: "Nom",
			registration: "Inscription",
			status: "Statut",
			visits: "Visites",
		},
		ticket: "fiche",
		tickets: "fiches",
		tooltips: {
			alreadyHasTicket: "Le consultant a déjà une fiche active dans ce rituel",
			edit: "Modifier",
			history: "Historique",
			newTicket: "Nouvelle fiche",
		},
	},
	photo: {
		addPhoto: "Appuyez pour ajouter une photo",
		capture: "Capturer",
		closeCamera: "Fermer la caméra",
		dragHere: "Glissez une image ou cliquez pour sélectionner",
		maxSize: "Taille maximale : {size} Mo",
		retake: "Reprendre",
		tabFile: "Fichier",
		tabWebcam: "Webcam",
		upload: "Mettre à jour la photo",
		uploadError: "Erreur lors de la mise à jour de la photo",
		uploadSuccess: "Photo mise à jour avec succès",
		webcamError: "Impossible d'accéder à la caméra",
	},
	roleHistory: {
		loadError: "Erreur lors du chargement de l'historique du parcours",
	},
	archive: {
		dialogTitle: "Archiver la personne",
		archiveAction: "Archiver",
		unarchiveAction: "Désarchiver",
		blockedByFinancialHistory: "Cette personne a des mouvements financiers et ne peut pas être supprimée — son historique fait partie de la reddition de comptes. Archivez-la : elle quitte les listes, les appels en cours sont annulés et toute la trace est conservée. Vous pourrez la désarchiver plus tard.",
		blockedByMandate: "Cette personne a un prélèvement automatique ACTIF. Annulez-le d'abord, sinon le prélèvement continue chez le prestataire de paiement même si la fiche quitte les listes.",
		reasonLabel: "Motif de l'archivage (facultatif)",
		reasonPlaceholder: "Ex. : a déménagé, s'est éloignée de la maison",
		archived: "{name} a été archivée.",
		unarchived: "{name} est de retour dans les listes.",
		error: "Impossible de terminer l'archivage.",
		banner: "Personne archivée par {user} le {date}. Elle n'apparaît pas dans les listes du quotidien.",
		filterLabel: "Archivées",
	},
	deleteDialog: {
		title: "Supprimer définitivement la personne",
		warning: "Cette action est irréversible et supprimera définitivement toutes les données liées à cette personne :",
		items: {
			journeyHistory: "Historique du parcours et hiérarchie",
			tickets: "Fiches de présence",
			messages: "Messages et notes",
			returns: "Retours",
			guides: "Associations de guides",
			functions: "Fonctions attribuées",
			financial: "Abonnements et transactions financières",
		},
		impactTitle: "Ce que cette personne a aujourd'hui :",
		impact: {
			openCharges: "Appels de fonds en cours",
			paidMovements: "Paiements enregistrés",
			subscriptions: "Inscriptions actives",
			tickets: "Fiches de consultation",
			messages: "Messages",
			nothing: "Rien enregistré — la fiche peut être supprimée sans perte.",
		},
		codeInstruction: "Pour confirmer, saisissez le code ci-dessous :",
		codePlaceholder: "Saisissez le code de confirmation",
		codeError: "Code incorrect",
		deleting: "Suppression en cours...",
	},
	mergeDialog: {
		menuLabel: "Doublon",
		title: "Fusionner une personne dans une autre",
		warning: "Cette action est irréversible. Tous les liens de \"{name}\" (parcours, fiches, messages, retours, guides, fonctions, finances) seront transférés vers la personne sélectionnée et \"{name}\" sera supprimée.",
		description: "Sélectionnez la personne qui recevra tout l'historique :",
		destinationLabel: "Personne destinataire",
		destinationHint: "La personne qui conservera tous les liens de la personne actuelle",
		sameAsSourceError: "La personne destinataire ne peut pas être la même que la source",
		codeInstruction: "Pour confirmer, saisissez le code ci-dessous :",
		codePlaceholder: "Saisissez le code de confirmation",
		codeError: "Code incorrect",
		confirm: "Fusionner et supprimer",
		merging: "Fusion en cours...",
		successMessage: "{source} a été fusionnée avec succès dans {destination}",
		errorMessage: "Erreur lors de la fusion des personnes",
	},
};
